
import tools00 from './tools0-0.png'
import tools01 from './tools0-1.png'
import tools10 from './tools1-0.png'
import tools11 from './tools1-1.png'
import tools20 from './tools2-0.png'
import tools21 from './tools2-1.png'
import tools30 from './tools3-0.png'
import tools31 from './tools3-1.png'
import tools40 from './tools4-0.png'
import tools41 from './tools4-1.png'
import tools50 from './tools5-0.png'
import tools51 from './tools5-1.png'
import main from './multi-device-main.png'
let toolsList = [
    {
        icon: tools00,
        iconSelected: tools01,
        name: 'iPhone iPhone iPad'
    },
    {
        icon: tools10,
        iconSelected: tools11,
        name: 'Android Phone Android Pad '
    },
    {
        icon: tools20,
        iconSelected: tools21,
        name: 'FireTV Stick'
    },
    {
        icon: tools30,
        iconSelected: tools31,
        name: 'Chromecast with Google TV'
    },
    {
        icon: tools40,
        iconSelected: tools41,
        name: 'Google Play 対応 SmartTV'
    },
    {
        icon: tools50,
        iconSelected: tools51,
        name: 'Google Play 対応 SmartTV BOX'
    }
]
export {
    toolsList as toolsList,
    main as main
}